import PointDrawing from './PointDrawing';
export default PointDrawing;
